export const assets = {
    ETH: {
        display: true,
        pythia: true,
        address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
        decimals: 18,
    },
    DAI: {
        display: true,
        pythia: true,
        address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        decimals: 18,
    },
    MANA: {
        display: true,
        pythia: true,
        address: '0x0F5D2fB29fb7d3CFeE444a200298f468908cC942',
        decimals: 18,
    },
    MKR: {
        display: true,
        pythia: true,
        address: '0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2',
        decimals: 18
    },
    SNX: {
        display: true,
        pythia: true,
        address: '0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F',
        decimals: 18,
    },
    SUSD: {
        display: true,
        pythia: true,
        address: '0x57Ab1ec28D129707052df4dF418D58a2D46d5f51',
        decimals: 18
    },
    UNI: {
        display: true,
        pythia: true,
        address: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
        decimals: 18
    },
    USDC: {
        display: true,
        decimals: 6,
        address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    },
    USDT: {
        display: true,
        pythia: true,
        address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
        decimals: 6
    },
    WBTC: {
        display: true,
        decimals: 8,
        pythia: true,
        address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599'
    },
}

export const comparisonAssets = {
    ETH: {},
    BTC: {},
    USDC: {},
}

export const dexs = {
    "uniswapv2": {},
    "Uniswap v3": {},
    "Curve": {},
    "Balancer": {},
    "Sushiswap": {},
}

export const timeWindows = {
    "7D": 7,
    "30D": 30,
    "180D": 180,
    "1Y": 365,
}